import React from "react";
import { ProviderIcon } from "../../../shared/ProviderIcon";
import { PROVIDER_ORDER, toAnalyseProvider } from "../providerMap";
import { ContextCardLink, GreenCheckIcon, SectionLabel } from "./shared";

function FootprintMetricRow({ label, strategy, valueKey }) {
	return (
		<>
			<span className="monitoring__analysis-strategy-footprint-label">{label}</span>
			{PROVIDER_ORDER.map((p) => {
				const data = strategy.providers.find(
					(pr) => toAnalyseProvider(pr.provider) === p
				);
				const value = data?.[valueKey]?.length ?? 0;
				return (
					<span key={`${label}-${p}`} className="monitoring__analysis-strategy-footprint-value">
						{value}
					</span>
				);
			})}
		</>
	);
}

export default function ResearchFootprintCard({ strategy, onViewDetails, embedded = false }) {
	const sourceTypes = strategy.source_analysis.source_types ?? [];

	const body = (
		<>
			<div className="monitoring__analysis-strategy-footprint-layout">
					<div className="monitoring__analysis-strategy-footprint-metrics">
						<div className="monitoring__analysis-strategy-footprint-grid">
							<span className="monitoring__analysis-strategy-footprint-corner" aria-hidden />
							{PROVIDER_ORDER.map((p) => (
								<span
									key={p}
									className="monitoring__analysis-strategy-footprint-provider"
									title={p}
								>
									<ProviderIcon provider={p} size={16} />
								</span>
							))}
							<FootprintMetricRow
								label="Queries Executed"
								strategy={strategy}
								valueKey="search_queries"
							/>
							<FootprintMetricRow
								label="Sources Analyzed"
								strategy={strategy}
								valueKey="sources"
							/>
						</div>
					</div>

					{sourceTypes.length > 0 && (
						<div className="monitoring__analysis-strategy-footprint-aside">
							<p className="monitoring__analysis-strategy-source-types-label mb-2">
								Common Source Types
							</p>
							<ul className="monitoring__analysis-strategy-source-type-list mb-0">
								{sourceTypes.map((st) => (
									<li key={st.type}>
										<GreenCheckIcon />
										<span>{st.type.replace(/_/g, " ")}</span>
									</li>
								))}
							</ul>
						</div>
					)}
				</div>

			<ContextCardLink onClick={onViewDetails}>View Fan-out Query For More Detail</ContextCardLink>
		</>
	);

	if (embedded) return body;

	return (
		<div className="monitoring__analysis-strategy-card monitoring__analysis-strategy-row-card monitoring__analysis-strategy-row-card--footprint monitoring__analysis-strategy-context-card">
			<div className="monitoring__analysis-strategy-card-head">
				<SectionLabel>AI Research Footprint</SectionLabel>
			</div>
			<div className="monitoring__analysis-strategy-card-body">{body}</div>
		</div>
	);
}
